// @flow

import Category from 'model/Category';
import { confluenceCloud } from 'data/products/confluence';
import { confluenceQuestionsCloud } from 'data/products/confluence.questions';

export default new Category('collaborate', confluenceCloud, confluenceQuestionsCloud);
